import { MoonIcon, BookIcon, WindIcon, SparkleIcon, IconProps } from '../components/icons';
import { Tint } from './mock';
import React from 'react';

/* ---------- Relaxation & Sleep (card-flows §5) ---------- */
/* Sessions are ElevenLabs narration tracks produced in the admin web and
   streamed or downloaded from R2 — the app finds and plays them, it never
   generates them. The "downloaded" badge ties into Settings → narration
   downloads (Sleep & relaxation category). */

export type SoundscapeId = 'rain' | 'waves' | 'none';
export type RelaxSession = {
  id: string;
  title: string;
  minutes: number;
  narrator: string;
  kind: string;
  icon: (p: IconProps) => React.ReactElement;
  tint: Tint;
  /* already on device (Settings → narration downloads) or streams from R2 */
  downloaded: boolean;
  /* what Sunny says to settle the user in before the track starts */
  intro: string;
};

/* the Tonight zone — four sessions, shortest to longest is deliberate variety */
export const SESSIONS: RelaxSession[] = [{
  id: 'wind-down',
  title: 'Wind-down',
  minutes: 10,
  narrator: 'Sunny · calm voice',
  kind: 'Guided breathing & letting go of the day',
  icon: MoonIcon,
  tint: 'lilac',
  downloaded: true,
  intro: "Let's slow everything down together. Get comfortable, and we'll begin."
}, {
  id: 'sleep-story',
  title: 'Sleep story',
  minutes: 20,
  narrator: 'Sunny · story voice',
  kind: 'Tonight: The Lighthouse Keeper',
  icon: BookIcon,
  tint: 'sky',
  downloaded: false,
  intro: 'Tonight’s story is The Lighthouse Keeper — slow, quiet, and a little bit salty.'
}, {
  id: 'box-breathing',
  title: 'Box breathing',
  minutes: 3,
  narrator: 'Sunny · calm voice',
  kind: 'In · hold · out · hold',
  icon: WindIcon,
  tint: 'sage',
  downloaded: true,
  intro: "Four counts in, four held, four out, four held. We'll do it together."
}, {
  id: 'body-scan',
  title: 'Body scan',
  minutes: 15,
  narrator: 'Sunny · calm voice',
  kind: 'Head-to-toe relaxation',
  icon: SparkleIcon,
  tint: 'butter',
  downloaded: false,
  intro: "We'll move slowly from the top of your head down to your toes, letting each part rest."
}];
export const SOUNDSCAPES: {
  id: SoundscapeId;
  label: string;
}[] = [{
  id: 'rain',
  label: 'Rain'
}, {
  id: 'waves',
  label: 'Waves'
}, {
  id: 'none',
  label: 'None'
}];

/* ---------- the sleep log ---------- */

export type SleepNight = {
  day: string;
  quality: number; /* 1–5 moons */
  hours: number;
};

/* the last 7 nights — last night is NOT yet logged, which is why the picker's
   "Last night" zone shows the quick entry rather than an existing entry */
export const SLEEP_WEEK: SleepNight[] = [{
  day: 'Tue',
  quality: 3,
  hours: 6.5
}, {
  day: 'Wed',
  quality: 4,
  hours: 7.5
}, {
  day: 'Thu',
  quality: 2,
  hours: 5
}, {
  day: 'Fri',
  quality: 4,
  hours: 8
}, {
  day: 'Sat',
  quality: 5,
  hours: 8.5
}, {
  day: 'Sun',
  quality: 4,
  hours: 7
}, {
  day: 'Mon',
  quality: 3,
  hours: 6.5
}];
export const BEDTIMES = ['9:30 pm', '10:00 pm', '10:30 pm', '11:00 pm', 'Later'];
export const WAKE_TIMES = ['6:00 am', '6:30 am', '7:00 am', '7:30 am', 'Later'];

/* 1–5 moons, warmest words for the best sleep */
export const QUALITY_LABELS = ['Rough', 'Not great', 'Okay', 'Good', 'Wonderful'];